import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchLogsEmails = async () => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/appiell/get_logs_emails/`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data.users.map((user) => ({
    email: user.email || "-",
    role: user.role || "-",
    full_name: `${user.first_name} ${user.last_name}` || "-",
  }));
};

const useGetLogsEmails = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["logs_emails"],
    queryFn: fetchLogsEmails,
    enabled,
  });
};

export default useGetLogsEmails;
